import apiClient from "Configuration/apiClient";
import API_CONFIG from "Configuration/apiConfig";

const AUTH_ENDPOINT = "/api/v1/auth";

export const login = (credentials) => {
  return apiClient.post(AUTH_ENDPOINT, credentials);
};

export const forgotPassword = (email) => {
  return apiClient.post(API_CONFIG.ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
};

export const verifyOtp = ({ email, otp }) => {
  return apiClient.post(API_CONFIG.ENDPOINTS.AUTH.VERIFY_OTP, { email, otp });
};

export const resetPassword = ({ resetToken, newPassword }) => {
  return apiClient.post(API_CONFIG.ENDPOINTS.AUTH.RESET_PASSWORD, {
    resetToken,
    newPassword,
  });
};

export const register = (payload) => {
  return apiClient.post(API_CONFIG.ENDPOINTS.AUTH.REGISTER, payload);
}

export const getRoles = () => {
  return apiClient.get(API_CONFIG.ENDPOINTS.AUTH.ROLES);
};

export default {
  login,
  forgotPassword,
  verifyOtp,
  resetPassword,
};